import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

// Your Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCM2XX7UQb97ROxQ755VXbEJu3nQzJP6Ac",
  authDomain: "exodiauno.firebaseapp.com",
  projectId: "exodiauno",
  storageBucket: "exodiauno.firebasestorage.app",
  messagingSenderId: "772100543231",
  appId: "1:772100543231:web:156c2e40c987eb1ef172ca",
  measurementId: "G-ZYBC8N4YFB"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication
export const auth = getAuth(app);

// Initialize Firebase Storage
export const storage = getStorage(app);

export default app;
